export const CREATE_RATING_ROUTE = '/create'
export const ADD_USER_ROUTE = '/add-user'
export const USER_PROFILE_ROUTE = '/users/:username'
export const LEADERBOARD_ROUTE = '/leaderboard'